.trigger {
  width: 100%;
}

.menu {
  min-width: 220px;
}

.row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 0;
}

.details {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
